import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlinePayment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={15}
    fill="none"
    viewBox="0 0 13 15"
    {...props}
  >
    <path
      stroke="#999"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M12.2 13.25a1.05 1.05 0 0 1-1.05 1.05H1.7a1.05 1.05 0 0 1-1.05-1.05V1.7A1.05 1.05 0 0 1 1.7.65h6.825L12.2 4.325z"
    />
    <path
      stroke="#999"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M8.212 5.74a1.4 1.4 0 0 0-1.32-.934H5.807a1.25 1.25 0 0 0-.267 2.47l1.65.362a1.4 1.4 0 0 1-.3 2.768h-.933a1.4 1.4 0 0 1-1.32-.933M6.425 4.806v-1.4M6.425 11.806v-1.4"
    />
  </svg>
);
export default SvgStreamlinePayment;
